import { render, staticRenderFns } from "./HotspotEditName.vue?vue&type=template&id=35454035"
import script from "./HotspotEditName.vue?vue&type=script&lang=js"
export * from "./HotspotEditName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports